import axios, { AxiosResponse } from 'axios'

import { NotificationTemplateRead } from '@generated/types'

const BASE_URL = '/api/template'

export default {
  async fetchAll(): Promise<AxiosResponse<NotificationTemplateRead[]>> {
    return axios.get(`${BASE_URL}/`)
  },

  async update(data: NotificationTemplateRead): Promise<AxiosResponse<NotificationTemplateRead>> {
    // Note: Original API used POST for update, adhering to that.
    return axios.post(`${BASE_URL}/`, data)
  },
}
